<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Oracle/Accounts">Oracle</b-breadcrumb-item>
            <b-breadcrumb-item active>Roles</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">Oracle Module Roles</div>
            <div class="card-body">
                <!-- The collapsable filter options -->
                <AppFormCardCollapsable :display-footer="true" @submit.prevent="onFilterSubmit" class="mb-3">
                    <template v-slot:header>Filter</template>
                    <template v-slot:body>
                        <div class="form-row">
                            <div class="col-md-4 col-sm-6 form-group">
                                <label>Organization Code</label>
                                <input
                                        class="form-control"
                                        placeholder="Organization Code"
                                        v-model="filterOptions.organizationCode"
                                />
                            </div>
                            <div class="col-md-4 col-sm-6 form-group">
                                <label>Role Name</label>
                                <input
                                        class="form-control"
                                        placeholder="Role Name"
                                        v-model="filterOptions.role"
                                />
                            </div>
                        </div>
                    </template>
                    <template v-slot:footer>
                        <button class="btn btn-primary" type="submit">Apply</button>
                    </template>
                </AppFormCardCollapsable>

                <div class="d-print-none dropdown mb-3 text-right">
                    <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                            data-toggle="dropdown" style="width: 100px" type="button">
                        <span>Actions</span>
                    </button>
                    <div class="dropdown-menu">
                        <RouterLink :to="{name: 'AddOracleModuleRole'}"
                                    class="btn btn-outline-light dropdown-item text-left" title="Add new module role">
                            <i class="fa fa-plus"></i>Add
                        </RouterLink>
                    </div>
                </div>

                <BTable
                        :busy="isLoading"
                        :fields="tableFields"
                        :items="moduleRoles"
                        :responsive="true"
                        show-empty
                        striped
                        table-class="table-align-middle">

                    <!-- Footer Pagination -->
                    <template v-slot:custom-foot>
                        <b-tr>
                            <b-td :colspan="tableFields.length">
                                <AppTablePagination
                                        :page.sync="filterOptions.page"
                                        :pageSize.sync="filterOptions.pageSize"
                                        :totalCount.sync="totalModuleRoles"
                                        v-on:update:page="loadData()"
                                        v-on:update:pageSize="loadData()"
                                ></AppTablePagination>
                            </b-td>
                        </b-tr>
                    </template>

                </BTable>

            </div>
        </div>

    </div>
</template>

<script>
    import AppFormCardCollapsable from "@/components/shared/AppFormCardCollapsable";
    import AppTablePagination from "@/components/shared/AppTablePagination";
    import {ToastType} from "@/services/models/shared/ToastType";
    import OracleService from "../../services/OracleService";

    export default {
        components: {
            AppFormCardCollapsable,
            AppTablePagination,
        },
        data() {
            return {
                isPerformingAction: false,
                moduleRoles: [],
                totalModuleRoles: 0,
                filterOptions: {
                    page: 1,
                    pageSize: 10,
                    organizationCode: null,
                    role: null,
                },
                isLoading: false,
                tableFields: [
                    {
                        key: 'organizationCode',
                        label: 'Organization Code',
                        thStyle: 'width:200px'
                    },
                    {
                        key: 'organizationName',
                        label: 'Organization Name',
                    },
                    {
                        key: 'role',
                        label: 'Role',
                    }
                ]
            }
        },
        methods: {
            /**
             * @description Loads the data from the API with the filter options bound to the component
             */
            loadData() {
                const vm = this;
                vm.isLoading = true;

                OracleService.getModuleOrganizationRoleList(vm.filterOptions)
                    .then(response => {
                        vm.moduleRoles = response.data;
                        vm.totalModuleRoles = response.totalCount;
                    }).catch(error => {
                    vm.alert(ToastType.Danger, error.response.statusText)
                }).finally(() => {
                    vm.isLoading = false;
                })
            },

            /**
             * @description Resets the page to the first page and reloads the data
             */
            onFilterSubmit() {
                this.filterOptions.page = 1;
                this.loadData();
            },
        },
        created() {
            this.loadData();
        }
    }
</script>
